import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_FLEET_PRESTART,
  setFleetPrestarts,
  DELETE_FLEET_PRESTART,
} from "../../store/fleet-prestart-store/reducer";

const FleetPreStart = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { fleetPrestarts } = useSelector(
    ({ fleetPreStart }) => fleetPreStart.fleetPreStartReducer
  );
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const [isLoading, setIsLoading] = useState(true);
  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Title",
        key: "title",
      },
      {
        label: "Usage Unit",
        key: "usageUnit",
      },
      {
        label: "Status",
        key: "status",
      },
      {
        label: "Categories",
        key: "categories",
      },
    ],
    data: [],
    fileName: "allFleetPrestart.csv",
  });
  const [dataList, setDataList] = useState([]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
    },
    {
      title: "Usage Unit",
      dataIndex: "usageUnit",
      key: "usageUnit",
      sorter: (a, b) => a?.usageUnit?.localeCompare(b?.usageUnit),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const handleColumnCsv = (array) => {
    let csvData = [];
    array.forEach((e) => {
      csvData.push({
        title: e.title,
        usageUnit: e.usageUnit,
        status: e.status,
        categories: e.categories,
      });
    });
    return csvData;
  };

  const FETCH_DATA = () => {
    FETCH_ALL_FLEET_PRESTART(organisationId)
      .then((data) => dispatch(setFleetPrestarts(data)))
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (fleetPrestarts) {
      const columns = handleColumnCsv(fleetPrestarts);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [fleetPrestarts]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    fleetPrestarts?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.title} - ${ele?.usageUnit}`,
        description: ``,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [fleetPrestarts]);


  return (
    <div className="table-organisations table-payments">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Fleet Prestarts" }]}
            dataSource={fleetPrestarts}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETE_FLEET_PRESTART}
            table="fleet/prestarts"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Fleet Prestarts" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETE_FLEET_PRESTART}
            table="fleet/prestarts"
          />
        </div>
      </div>
    </div>
  );
};

export default FleetPreStart;
